import { makeAutoObservable, runInAction } from 'mobx';
import { API_ADMIN_APP_VERSION } from 'consts';
import { AxiosMethod, LoadingStatus } from 'enums';
import { NetworkRequestHandler } from 'http/NetworkRequestHandler';
import { Toast } from 'primereact/toast';
import React from 'react';
import { BASE_URL } from 'http/api';

export interface IAppVersion {
  store: string;
  validVersion: string | null;
  outdatedVersion: string | null;
}

class VersioningStore {
  versions: IAppVersion[] = [];

  status: LoadingStatus = LoadingStatus.IDLE;

  updatingStore: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  async getAppVersions(toast: React.MutableRefObject<Toast | null> | null) {
    this.status = LoadingStatus.PENDING;
    try {
      const data = await NetworkRequestHandler.sendRequest({
        method: AxiosMethod.GET,
        url: `${BASE_URL}${API_ADMIN_APP_VERSION}`,
      });
      runInAction(() => {
        this.versions = data;
        this.status = LoadingStatus.DONE;
      });
    } catch (error: any) {
      runInAction(() => {
        this.status = LoadingStatus.ERROR;
        toast?.current?.show({
          severity: 'error',
          summary: 'Ошибка',
          detail: error.response.data.message,
          life: 3000,
        });
      });
    }
  }

  async updateAppVersion(
    store: string,
    validVersion: string,
    outdatedVersion: string,
    toast: React.MutableRefObject<Toast | null> | null,
  ) {
    this.updatingStore = store;
    this.status = LoadingStatus.PENDING;
    try {
      await NetworkRequestHandler.sendRequest({
        method: AxiosMethod.POST,
        url: `${BASE_URL}${API_ADMIN_APP_VERSION}`,
        data: { store, validVersion, outdatedVersion },
      });
      runInAction(() => {
        this.getAppVersions(toast);
      });
    } catch (error: any) {
      runInAction(() => {
        this.status = LoadingStatus.ERROR;
        toast?.current?.show({
          severity: 'error',
          summary: 'Ошибка',
          detail: error.response.data.message,
          life: 3000,
        });
      });
    } finally {
      runInAction(() => {
        this.updatingStore = null;
        this.status = LoadingStatus.DONE;
      });
    }
  }
}

export default new VersioningStore();
